import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

/*const {
    REACT_APP_FIREBASE_API_KEY,
    REACT_APP_AUTH_DOMAIN,
    REACT_APP_DATABASE_URL,
    REACT_APP_PROJECT_ID,
    REACT_APP_STORAGE_BUCKET,
    REACT_APP_MESSAGING_SENDER_ID,
    REACT_APP_APP_ID,
    REACT_APP_MEASUREMENT_ID,
} = process.env;
export const firebaseConfig = {
    apiKey: REACT_APP_FIREBASE_API_KEY,
    authDomain: REACT_APP_AUTH_DOMAIN,
    databaseURL: REACT_APP_DATABASE_URL,
    projectId: REACT_APP_PROJECT_ID,
    storageBucket: REACT_APP_STORAGE_BUCKET,
    messagingSenderId: REACT_APP_MESSAGING_SENDER_ID,
    appId: REACT_APP_APP_ID,
    measurementId: REACT_APP_MEASUREMENT_ID,
};*/

const firebaseConfig = {
    apiKey: "AIzaSyAIkqn5kGXlNTNqQoAqs93qCwYNs5ceGMc",
    authDomain: "fetchnerusmanmonney.firebaseapp.com",
    projectId: "fetchnerusmanmonney",
    storageBucket: "fetchnerusmanmonney.appspot.com",
    messagingSenderId: "806835118728",
    appId: "1:806835118728:web:753a240f60086efa8bf53d",
    measurementId: "G-XGTCNPDZND"
};



const app = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();

export {db, auth, storage};


